// extracted by mini-css-extract-plugin
export default {"brandTags":"zCfXBIjwROmFR_XsEWa_","brandTag":"qx1oBbOxZZAWuVi6yg3n"};